type Listener = () => void;

class StorageSubscription {
    private listeners: Map<string, Set<Listener>>;

    constructor() {
        this.listeners = new Map();
    }

    subscribe(key: string, callback: Listener): () => void {
        if (!this.listeners.has(key)) {
            this.listeners.set(key, new Set());
        }

        this.listeners.get(key)!.add(callback);

        return () => this.unsubscribe(key, callback);
    }

    private unsubscribe(key: string, callback: Listener): void {
        const keyListeners = this.listeners.get(key);

        if (keyListeners) {
            keyListeners.delete(callback);

            if (keyListeners.size === 0) {
                this.listeners.delete(key);
            }
        }
    }

    notify(key: string): void {
        const keyListeners = this.listeners.get(key);

        if (keyListeners) {
            keyListeners.forEach((listener) => listener());
        }
    }
}

export const storageSubscription = new StorageSubscription();
